import { FallbackProps } from "react-error-boundary";
import { Box, Typography, Button } from "@mui/material";

/**
 * Error Fallback component for React Error Boundary
 * Displays a user-friendly error message with a retry button
 */
export default function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const errorMessage = error instanceof Error ? error.message : String(error) || 'An unexpected error occurred';
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom color="error">
        Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 600 }}>
        {errorMessage}
      </Typography>
      <Button variant="contained" onClick={resetErrorBoundary}>
        Try again
      </Button>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
        Check the browser console for more details
      </Typography>
    </Box>
  );
}

